import React, { Dispatch, SetStateAction } from "react";
import { performSearch, sanitizeURLForQueryParams } from "utils";
import { WpCategory, WpPage, WpPost, WpProject_Gallery, WpProject_Gallery_Category } from "codegen";
import "./FilterSearch.scss";
import { navigate } from "gatsby-link";

interface FilterSearchProps {
  dropdownItems?: (WpCategory | WpProject_Gallery_Category)[] & any; // Account for Intrinsic Types
  contentToSearch: (WpPost | WpPage | WpProject_Gallery)[] & any; //Account for Intrinsic Types
  setSearchResults:
    | Dispatch<SetStateAction<WpPost[]>>
    | Dispatch<SetStateAction<WpPage[]>>
    | Dispatch<SetStateAction<WpProject_Gallery[]>>;
  placeholderText?: string;
  defaultItem?: WpCategory;
}

/**
 * Component that will search through any set of posts or pages that are passed down
 *
 * @param contentToSearch - Content to search
 * @param placeholderText - Default "Search...". Insert if the inputs should display an alternative
 * @param setSearchResults - Sets search results
 * @returns Search functionality through posts or pages that are passed down
 *
 */
export const FilterSearch = ({
  contentToSearch = [],
  placeholderText = "Search...",
  setSearchResults,
}: FilterSearchProps): JSX.Element => {
  return (
    <div className="filter--searchbar">
      <input
        name="filter"
        type="search"
        onChange={(event) => {
          event.preventDefault();
          navigate(`${sanitizeURLForQueryParams(window.location.pathname)}s=${event.target.value}`);
          performSearch(contentToSearch, setSearchResults, event.target.value);
        }}
        placeholder={placeholderText}
      />
    </div>
  );
};
